import { ArrowsClockwise, Sparkle } from '@phosphor-icons/react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface AppUpdateDialogProps {
  open: boolean
  onUpdate: () => void
}

export function AppUpdateDialog({ open, onUpdate }: AppUpdateDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent
        className="sm:max-w-md"
        onEscapeKeyDown={(event) => event.preventDefault()}
      >
        <AlertDialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-indigo-100 text-indigo-600">
            <Sparkle className="h-6 w-6" weight="fill" />
          </div>
          <AlertDialogTitle className="text-center">
            Nova versão disponível
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            Uma atualização do ImobDesk já está no ar. Para continuar usando o
            sistema com as correções e melhorias mais recentes, é preciso
            atualizar agora.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-center">
          <AlertDialogAction
            className="min-w-[200px] gap-2"
            onClick={onUpdate}
          >
            <ArrowsClockwise className="h-4 w-4" />
            Atualizar agora
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
